import * as apiUtils from "@/utils/apiUtils"
import moment from "moment"

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {},
  // -----------------------------------------------------------------
  getters: {},
  // -----------------------------------------------------------------
  mutations: {},
  // -----------------------------------------------------------------
  actions: {
    // Invoices
    getInvoice: (context, tid) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/sales/invoices/" + tid
      return apiUtils
        .get(path)
        .then(function(response) {
          response.data.endDate = moment(response.data.expiredAt).format("YYYY-MM-DD")
          response.data.startDate = moment(response.data.issuedAt).format("YYYY-MM-DD")

          return Promise.resolve(response)
        })
        .catch(function(error) {
          return Promise.reject(error)
        })
    },
    getInvoices: (context, query) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/sales/invoices"
      return apiUtils.get(path, query)
    },
    getInvoicesByStatus: (context, status) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/sales/invoices?status=" + status
      return apiUtils.get(path)
    },
    getInvoicesByTimeRange: (context, { from, to }) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/sales/invoices?from=" + from + "&to=" + to
      return apiUtils.get(path)
    },
    createInvoice: (
      context,
      { name, number, currencyCode, customerId, issuedAt, expiredAt, poso, subHeader, footer, memo, items }
    ) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/sales/invoices"
      return apiUtils.post(path, {
        name,
        number,
        currencyCode,
        customerId,
        issuedAt,
        expiredAt,
        poso,
        subHeader,
        footer,
        memo,
        items
      })
    },
    updateInvoice: (
      context,
      { id, name, number, currencyCode, customerId, issuedAt, expiredAt, poso, subHeader, footer, memo, items }
    ) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/sales/invoices/" + id
      return apiUtils.patch(path, {
        name,
        number,
        currencyCode,
        customerId,
        issuedAt,
        expiredAt,
        poso,
        subHeader,
        footer,
        memo,
        items
      })
    },
    deleteInvoice: (context, id) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/sales/invoices/" + id
      return apiUtils.delete(path)
    },
    shareInvoice: (context, id) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/sales/invoices/" + id + "/share"
      return apiUtils.post(path)
    },
    getShareInvoice: (context, id) => {
      var path = "/shares/invoices/" + id
      return apiUtils.get(path)
    },
    sendInvoiceByEmail: (context, { id, emails, from, cc }) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/sales/invoices/" + id + "/send-by-email"
      return apiUtils.post(path, {
        emails,
        from,
        cc
      })
    },
    duplicateInvoice: (context, id) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/sales/invoices/" + id + "/duplicate"
      return apiUtils.post(path)
    },
    approveInvoice: (context, id) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/sales/invoices/" + id + "/approve"
      return apiUtils.post(path)
    },
    sendInvoiceReminder: (context, { id, from, cc }) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/sales/invoices/" + id + "/send-reminder"
      return apiUtils.post(path)
    },
    sendInvoiceReminderByEmail: (context, { id, emails, from, cc }) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/sales/invoices/" + id + "/send-reminder-by-email"
      return apiUtils.post(path, {
        emails,
        from,
        cc
      })
    },
    recordInvoicePayment: (context, { invoiceId, paymentAccountId, amount, note, date }) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/sales/invoices/" + invoiceId + "/record-payment"
      return apiUtils.post(path, {
        paymentAccountId,
        amount,
        note,
        date
      })
    },
    convertToBill: (context, id) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/sales/invoices/" + id + "/convert-to-bill"
      return apiUtils.post(path)
    },
    // get invoice to bills
    getInvoiceToBills: (context, query) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/sales/invoice-to-bills"
      return apiUtils.get(path, query)
    },
    // delete invoice to bill
    deleteInvoiceToBills: (context, id) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/sales/invoice-to-bills/" + id
      return apiUtils.delete(path)
    }
  }
}
